const RED = `#F43D26`
const ORANGE = `#FF922E`
const AMBER = `#FDCF2A`
const BLUE = `#1FA3CF`
const GREEN = `#19A84F`
const VIOLET = `#3C2854`
const LIGHT_RED = `#FFC5B9`
const LIGHT_ORANGE = `#F8CA87`
const DARK_GREEN = `#00491C`
const DARK_BLUE = `#003171`
const LIGHT_BLUE = `#93DEEB`
const LIGHT_VIOLET = `#CBC1EC`
const BRAND = `#F6F404`
const GREY = `#BCBBB8`
const GREY_LIGHT = `#E4E3DD`
const GREY_LIGHTEST = `#E4E3DD`
const COAL = `#19282D`
const COAL_LIGHT = `#3B484C`
const COAL_LIGHTEST = `#8c9396`
const WHITE = `#FFFFFF`
const DARK_RED = `#FF0000`

const palette = {
  brand: BRAND,
  white: WHITE,
  link: BLUE,
  error: RED,
  info: BLUE,
  alert: ORANGE,
  valid: GREEN,
  important: DARK_RED,
  coal: {
    dark: COAL,
    light: COAL_LIGHT,
    lightest: COAL_LIGHTEST,
  },
  grey: {
    dark: GREY,
    light: GREY_LIGHT,
    lightest: GREY_LIGHTEST,
  },
  full: {
    red: RED,
    orange: ORANGE,
    amber: AMBER,
    green: GREEN,
    blue: BLUE,
    violet: VIOLET,
    lightRed: LIGHT_RED,
    lightOrange: LIGHT_ORANGE,
    darkGreen: DARK_GREEN,
    darkBlue: DARK_BLUE,
    lightBlue: LIGHT_BLUE,
    lightViolet: LIGHT_VIOLET,
  },
}

export const surface = {
  background: COAL,
  color: WHITE,
}

export default palette
